// Half-hourly time-of-day options offered by ScheduleStep when a day is
// toggled on. Format: value is 24-hour 'HH:MM' (what gets persisted to
// the campaign's daySchedule object); label is 12-hour AM/PM for display.
// Ported from prototypes/campaign-creation-prototype.jsx lines 349-360.

const buildTimeOptions = () => {
  const out = [];
  for (let h = 12; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const hh = String(h).padStart(2, '0');
      const mm = String(m).padStart(2, '0');
      const value = `${hh}:${mm}`;
      const hour12 = h === 12 ? 12 : h - 12;
      const ampm = 'PM';
      const label = `${hour12}:${mm} ${ampm}`;
      out.push({ value, label });
    }
  }
  return out;
};

export const TIME_OPTIONS = buildTimeOptions();
export const DEFAULT_DAY_TIME = '19:00';
